import React from 'react'
import styled, { keyframes } from 'styled-components'

const TagLocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: ${({ theme }) => theme.bg2};
  color: #4afc39;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`
const TagUnlocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: #4afc39;
  color: #1e1e1e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`

const TagHypurrFi = styled.div`
  min-width: 120px;
  background: rgb(161, 252, 231);
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  color: rgb(12, 12, 14);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`
const gradientMove = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`
const TagHotApr = styled.div`
  background: linear-gradient(45deg, #ff0000 0%, #fdcf58 25%, #ff0000 50%, #fdcf58 75%, #ff0000 100%);
  border-radius: 8px;
  animation: ${gradientMove} 3s ease infinite;
  height: 22px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 200% 200%;

  .content {
    font-size: 0.75rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 6px;
    background: ${({ theme }) => theme.bg0};
    border-radius: 8px;
    height: 20px;
  }
`

const TagIncentive = styled.div`
  background: ${({ theme }) => `linear-gradient(
          45deg,
          ${theme.primary1} 0%,
          ${theme.primary2} 25%,
          ${theme.primary3} 50%,
          ${theme.primary2} 75%,
          ${theme.primary1} 100%
        )`};
  border-radius: 8px;
  animation: ${gradientMove} 3s ease infinite;
  height: 22px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 200% 200%;

  .content {
    font-size: 0.75rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 6px;
    background: ${({ theme }) => theme.bg0};
    border-radius: 8px;
    height: 20px;
  }
`

interface TagI {
  variant: 1 | 2 | 3 | 4 | 5
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
  style?: React.CSSProperties
}

const Tag: React.FC<TagI> = ({ variant = 1, style, children }) => {
  return (
    <>
      {variant === 1 && <TagLocked style={{ ...(style ? style : {}) }}>{children}</TagLocked>}

      {variant === 2 && <TagUnlocked style={{ ...(style ? style : {}) }}>{children}</TagUnlocked>}

      {variant === 3 && <TagHypurrFi style={{ ...(style ? style : {}) }}>{children}</TagHypurrFi>}

      {variant === 4 && (
        <TagHotApr style={{ ...(style ? style : {}) }}>
          <div className="content">{children}</div>
        </TagHotApr>
      )}

      {variant === 5 && (
        <TagIncentive style={{ ...(style ? style : {}) }}>
          <div className="content">{children}</div>
        </TagIncentive>
      )}
    </>
  )
}
export default Tag
